import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CrudService, IApplicationResponse, ModulesBasedApiSuffix, ResponseMessageTypes,
  RxjsService, SnackbarService, prepareRequiredHttpParams
} from '@app/shared';
import { InventoryModuleApiSuffixModels } from '@modules/inventory/shared';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-job-selection-audit-cycle-count',
  templateUrl: './job-selection-audit-cycle-count.component.html',
  styleUrls: ['./job-selection-audit-cycle-count.component.scss']
})
export class JobSelectionAuditCycleCountComponent implements OnInit {

  auditCycleCountId: any;
  auditIterationId: any;
  auditCycleCountDetails: any = {};
  auditSystem: any;
  auditUserselection: any;
  auditHighRiskItems: any;
  randomSelection: any;
  createdUserId: string = '';
  isEdit = 0;
  primengTableConfigProperties: any;
  jobSelectionViewDetail: any;

  constructor(
    private router: Router, private activatedRoute: ActivatedRoute,
    private snackbarService: SnackbarService,
    private rxjsService: RxjsService, private crudService: CrudService,
  ) {
    this.auditCycleCountId = this.activatedRoute.snapshot.queryParams.id;
    this.auditIterationId = this.activatedRoute.snapshot.queryParams.iterationId;
    this.createdUserId = this.activatedRoute.snapshot.queryParams.userId;
    this.isEdit = this.activatedRoute.snapshot.queryParams.isEdit;
    this.onShowValue();
    this.primengTableConfigProperties = {
      tableCaption: "Job Selection",
      breadCrumbItems: [{ displayName: 'Inventory Management' }, { displayName: 'Job Selection', isClick: true },
      { displayName: 'Stock Count', isClick: true }, { displayName: 'Audit Cycle Count List', isClick: true },
      { displayName: 'Audit Cycle Count' }],
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            enableBreadCrumb: true,
            enableClearfix: true,
          }
        ]
      }
    };
  }

  ngOnInit() {

    if (this.auditCycleCountId && this.auditIterationId) {
      this.getDetailsById();
      this.getInprogressItemDetails();
    }
  }
  onStorageLocation() {
    this.crudService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.AUDIT_CYCLE_COUNT_DETAILS_LIST,
      undefined, true, prepareRequiredHttpParams({
        auditCycleCountId: this.auditCycleCountId, auditCycleCountIterationId: this.auditIterationId,
        createdUserId: this.createdUserId
      })).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200) {
          if (response.resources != null) {
            //let getDetails = response.resources;
            // let value = getDetails.auditCycleCountRefTypeId == 12 ? 'system' : getDetails.auditCycleCountRefTypeId == 11 ? 'user' : 'high';
            //  this.navigateToScanPage(value, getDetails.auditCycleCountRefTypeId, 1);
            this.rxjsService.setGlobalLoaderProperty(false);
          }
          else {
            this.getDetailsById();
          }
        }
        else {
          this.snackbarService.openSnackbar(response.message, ResponseMessageTypes.ERROR);
          this.rxjsService.setGlobalLoaderProperty(false);
        }

      });

  }
  getInprogressItemDetails() {

    let params = new HttpParams().set('auditCycleCountId', this.auditCycleCountId)
      .set('auditCycleCountIterationId', this.auditIterationId).set('createdUserId', this.createdUserId);
    this.crudService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.AUDIT_CYCLE_COUNT_INPROGRESS_ITEMS, undefined, true, params)
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200) {
          if (response.resources.itemId != null) {
            let getDetails = response.resources;
            let value = getDetails.auditCycleCountRefTypeId == 12 ? 'system' : getDetails.auditCycleCountRefTypeId == 11 ? 'user' : 'high';
            this.navigateToScanPage(value, getDetails.auditCycleCountRefTypeId, 1);
            this.rxjsService.setGlobalLoaderProperty(false);
          }
          else {
            this.getDetails();
          }
        }
        else {
          this.snackbarService.openSnackbar(response.message, ResponseMessageTypes.ERROR);
          this.rxjsService.setGlobalLoaderProperty(false);
        }
      });
  }

  getDetailsById() {
    let params = new HttpParams().set('AuditCycleCountId', this.auditCycleCountId).set('AuditCycleCountIterationId', this.auditIterationId);
    forkJoin([
      this.crudService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.AUDIT_CYCLE_COUNT_DETAILS, undefined, true, params)
    ]).subscribe((response: IApplicationResponse[]) => {
      response.forEach((resp: IApplicationResponse, ix: number) => {
        if (resp.isSuccess && resp.statusCode === 200) {
          switch (ix) {
            case 0:
              this.auditCycleCountDetails = resp.resources;
              this.onShowValue();
              this.rxjsService.setGlobalLoaderProperty(false);
              break;
            default:
              this.rxjsService.setGlobalLoaderProperty(false);
              break;
          }
        }
        else {
          this.snackbarService.openSnackbar(resp.message, ResponseMessageTypes.ERROR);
          this.rxjsService.setGlobalLoaderProperty(false);
        }
      });
    });
  }

  breadCrumbItemsClick(e) {
    if (e?.displayName == 'Job Selection') {
      this.navigateToJobSelection();
    } else if (e?.displayName == 'Stock Count') {
      this.navigateToJobSelection();
    } else if (e?.displayName == 'Audit Cycle Count List') {
      this.navigateToAuditCycleCountList();
    }
  }

  onShowValue() {
    this.jobSelectionViewDetail = [
      { name: 'Audit Cycle Count ID', value: this.auditCycleCountDetails?.auditCycleCountNumber, className: 'ml-3', order: 1 },
      { name: 'Warehouse', value: this.auditCycleCountDetails?.warehouseName, order: 2 },
      { name: 'Count', value: this.auditCycleCountDetails?.auditCycleCountIterationNumber, order: 3 },
    ]
  }
  getDetails() {
    let params = new HttpParams().set('AuditCycleCountId', this.auditCycleCountId).set('AuditCycleCountIterationId', this.auditIterationId)
      .set('createdUserId', this.createdUserId);
    this.crudService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.AUDIT_CYCLE_COUNT_DETAILS_LIST, undefined, true, params)
      .subscribe((response: IApplicationResponse) => {

        if (response.isSuccess && response.statusCode === 200) {

          if (response.resources.length > 0) {
            response.resources.forEach(x => {
              if (x.auditCycleCountRefTypeName?.toLowerCase() == "high risk items") {
                this.auditHighRiskItems = x.progresspercentage;
              }
              else if (x.auditCycleCountRefTypeName?.toLowerCase() == "user selection") {
                this.auditUserselection = x.progresspercentage;
              }
              else {
                this.auditSystem = x.progresspercentage;
              }
            });
          }
          if (response.resources.length >= 3) {
            this.randomSelection = (this.auditUserselection + this.auditHighRiskItems) / 2;
          }
          this.rxjsService.setGlobalLoaderProperty(false);
        }
        else {
          this.snackbarService.openSnackbar(response.message, ResponseMessageTypes.ERROR);
          this.rxjsService.setGlobalLoaderProperty(false);
        }
      });
  }
  navigateToJobSelection() {
    this.router.navigate(['/inventory', 'job-selection'], { skipLocationChange: true });
  }

  navigateToAuditCycleCountList() {
    this.router.navigate(['/inventory', 'job-selection', 'audit-cycle-count-list'], { queryParams: { isEdit: this.isEdit, }, skipLocationChange: true });
  }

  navigateToScanPage(value: string, id: number, index: number, val?: number) {
    let type = value == 'system' ? 'system gnerated' : value == 'user' ? 'user selection' : value == 'high' ? 'high risk items' : null;
    if (val == 100) {
      this.snackbarService.openSnackbar("All " + type + " stock codes are counted for this count.", ResponseMessageTypes.WARNING);
      return;
    }

    this.router.navigate(['/inventory', 'job-selection', 'audit-cycle-count-scan'], {
      queryParams: {
        id: this.auditCycleCountId,
        iterationId: this.auditIterationId,
        type: value,
        refTypeId: id,
        tabIndex: index,
        isEdit: this.isEdit,
      }, skipLocationChange: true
    });
  }

}
